import React, { useState, useEffect } from 'react'
import { HiChevronLeft, HiChevronRight } from 'react-icons/hi'
import { motion } from 'framer-motion'

import wrapper from '../../utilities/Wrapper'
import motionWrapper from '../../utilities/MotionWrapper'
import { urlFor, client } from '../../utilities/index'
import './Testimonials.scss'

const Testimonials = () => {
  const [brands, setBrands] = useState([])
  const [testimonials, setTestimonials] = useState([])
  const [currentIndex, setCurrentIndex] = useState(0)

  const handleClick = index => setCurrentIndex(index)
  useEffect(() => {
    const testimonialsQuery = '*[_type == "testimonials"]'
    const brandsQuery = '*[_type == "brands"]'

    client.fetch(testimonialsQuery).then(data => {
      setTestimonials(data)
    })

    client.fetch(brandsQuery).then(data => {
      setBrands(data)
    })
  }, [])
  const currTestimonial = testimonials[currentIndex]
  return (
    <>
      {testimonials.length && (
        <>
          <div className='app__testimonial-item app__flex dark:bg-slate-900'>
            <img
              src={urlFor(currTestimonial.imgurl)}
              alt={currTestimonial.name}
            />
            <div className='app__testimonial-content'>
              <p className='p-text dark:text-white'>
                {currTestimonial.feedback}
              </p>
              <div>
                <h4 className='bold-text dark:text-blue-400'>
                  {currTestimonial.name}
                </h4>
                <h5 className='p-text  dark:text-slate-400'>
                  {currTestimonial.company}
                </h5>
              </div>
            </div>
          </div>

          <div className='app__testimonial-btns app__flex'>
            <button
              className='app__flex dark:bg-slate-900 dark:hover:bg-slate-600'
              onClick={() =>
                handleClick(
                  currentIndex === 0
                    ? testimonials.length - 1
                    : currentIndex - 1
                )
              }
            >
              <HiChevronLeft className='dark:text-white' />
            </button>

            <button
              className='app__flex dark:bg-slate-900 dark:hover:bg-slate-600'
              onClick={() =>
                handleClick(
                  currentIndex === testimonials.length - 1
                    ? 0
                    : currentIndex + 1
                )
              }
            >
              <HiChevronRight className='dark:text-white' />
            </button>
          </div>
          <div className='app__testimonial-brands app__flex'>
            {brands.map(brand => (
              <motion.div
                whileInView={{ opacity: [0, 1] }}
                transition={{ duration: 0.5, type: 'tween' }}
                key={brand._id}
              >
                <img src={urlFor(brand.imgUrl)} alt={brand.name} />
              </motion.div>
            ))}
          </div>
        </>
      )}
    </>
  )
}

export default wrapper(
  motionWrapper(Testimonials, 'app__testimonial'),
  'testimonial',
  'app__primarybg dark:bg-slate-800'
)
